"use client";
import { LicenseInfo } from "@mui/x-license";

LicenseInfo.setLicenseKey(
  "6940c548fed302d491c4d73170b48619Tz0xMjk3ODgsRT0xODEyNDEyNzk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9aW5pdGlhbCxLVj0y",
);

export default function MuiXLicense() {
  return null;
}
